import { z } from "zod"

// Coerce various inputs to string, preserving null when appropriate
const zStringishNullable = z.preprocess((val) => {
  if (val === null || val === undefined || val === "") return null
  return String(val)
}, z.string().nullable())

const zStringish = z.preprocess((val) => {
  if (val === null || val === undefined) return ""
  return String(val)
}, z.string())

const zNumberOrStringToNumberNullable = z.preprocess((val) => {
  if (val === null || val === undefined || val === "") return null
  if (typeof val === "string") {
    const cleaned = val.replace(/\s/g, "").replace(",", ".")
    const num = Number(cleaned)
    return Number.isNaN(num) ? null : num
  }
  if (typeof val === "number") return val
  return null
}, z.number().nullable())

const zNumberOrStringToNumber = z.preprocess((val) => {
  if (val === null || val === undefined || val === "") return 0
  if (typeof val === "string") {
    const cleaned = val.replace(/\s/g, "").replace(",", ".")
    const num = Number(cleaned)
    return Number.isNaN(num) ? 0 : num
  }
  if (typeof val === "number") return val
  return 0
}, z.number())

const UserInner = z.object({
  id: z.number(),
  username: z.string(),
  first_name: z.string(),
  last_name: z.string().nullable(),
  auth_key: z.string(),
  password_hash: z.string(),
  password_reset_token: z.string().nullable(),
  email: z.string(),
  status: z.number(),
  agency_id: z.number(),
  created_at: z.number(),
  updated_at: z.number(),
  is_online: z.number(),
  sidebar_left_visible: z.number(),
  sidebar_right_visible: z.number(),
  verification_token: z.string().nullable(),
  type: zNumberOrStringToNumber,
  moderate_posts: zStringishNullable,
  avatar: z.string().nullable(),
  two_fa_type: z.enum(["email", "authenticator"]).optional().nullable(),
  failed_2fa_attempts: z.number().optional(),
  Subdominio: z.string().nullable(),
  daily_newsletter_enabled: z.number(),
  has_llego: zStringishNullable,
  user_llego: z.string().nullable(),
  pass_llego: z.string().nullable(),
})

const AgencyZod = z.object({
  id: z.number(),
  name: z.string(),
  district: z.string(),
  RNAVT: z.string(),
  nif: z.string(),
  address: z.string(),
  locale: z.string(),
  postal_code: z.string(),
  phone_number: zNumberOrStringToNumberNullable,
  status: z.number(),
  email: z.string(),
  subdomain: z.string(),
  logo: z.string(),
  bd_egoi: z.string(),
  social_denomination: z.string(),
  facebook_url: z.string(),
  subdomain_qrcode_path: z.string().nullable(),
  facebook_qrcode_path: z.string().nullable(),
  logo_path: z.string().nullable(),
  instagram_url: z.string(),
  agency_id: z.number().nullable(),
  accession_date: z.string().nullable(),
  representative: zStringish,
  is_master: zNumberOrStringToNumber,
  instagram_qrcode_path: z.string().nullable(),
  color: zStringish,
})

export const UserSchema = z.object({
  user: UserInner,
  agency: AgencyZod,
  company: z.string().nullable().optional(),
  can: z.record(z.string(), z.boolean()),
  avatar_url: z.string().nullable().optional(),
  full_name: z.string().nullable().optional(),
})

export type UserIdentity = z.infer<typeof UserInner>
export type Agency = z.infer<typeof AgencyZod>
export type User = z.infer<typeof UserSchema>
